// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { qtyFieldStyles } from "@stoneage/App/Components/Qty/QtyField";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

qtyFieldStyles.actionButton = {
    css: css`
        background-color: ${color("common.ui3")};
        display: flex;
        flex: 0 0 20px;
        align-items: center;
        height: 100%;
        justify-content: center;
        ${IconWrapper} {
            color: ${color("common.ui8")};
            &,
            svg {
                width: 11px;
                height: 13px;
            }
        }

        &:disabled {
            background-color: ${color("common.ui4")};
            ${IconWrapper} {
                color: ${color("common.ui5")};
            }
        }
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            ${IconWrapper} {
                color: ${color("primary")};
            }
        }
    `,
};

qtyFieldStyles.wrapper = {
    css: css`
        background: ${color("common.ui3")};
        display: flex;
        align-items: center;
        height: 26px;
        min-width: 90px;
        width: 90px;
        overflow: hidden;
        overflow-x: hidden;
        border: 1px solid ${color("common.ui7")};
        ${({ showActionButton }: any) =>
            !showActionButton &&
            css`
                &:hover {
                    border-color: ${color("primary")};
                }
            `}
        ${({ showActionButton }: any) =>
            !showActionButton &&
            `
                min-width: 42px;
                width: 42px;
        `}

        ${({ isDisabled }: any) =>
            isDisabled &&
            `
                opacity: 0.33;
                background: ${getColor("common.ui4")};
                box-shadow: 0 0 0 1px ${getColor("common.ui6")}; 
                input, button {
                    opacity: 1;
                    background: transparent;
               }
        `}
    `,
};

qtyFieldStyles.editableQuantityTextField = {
    sizeVariant: "small",
    mergeCss: true,
    cssOverrides: {
        formField: css`
            ${TypographyStyle} {
                text-align: center;
            }

            &&& {
                input {
                    &,
                    &:hover:not(:disabled),
                    &:focus:not(:disabled) {
                        border: none;
                        border-radius: 0;
                        outline: none;
                        box-shadow: none;
                        padding: 0 2px;
                    }
                }

                ${({ showActionButton }: any) =>
                    !showActionButton &&
                    `
                    input {
                        height: 26px;
                    }
                `}
            }
        `,
        formInputWrapper: css`
            &,
            &:hover:not(:disabled),
            &:focus:not(:disabled) {
                border: none;
                box-shadow: none;
                padding: 0;
            }
        `,
        inputSelect: css`
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            height: 26px;
        `,
    },
};

qtyFieldStyles.container = {
    css: css`
        display: inline-flex;
        gap: 6px;
        align-items: center;
        flex-wrap: wrap;
        max-width: 72px;
    `,
};

qtyFieldStyles.valueText = {
    size: 16,
    lineHeight: "17px",
    weight: "bold",
};

qtyFieldStyles.qtyLabelNotEditable = {
    size: 12,
    lineHeight: "13px",
    weight: "normal",
    css: css`
        line-height: 13px;
        text-transform: capitalize;
        padding: 0;
        margin-bottom: 8px;
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
        }
        @media print {
            &&& {
                font-size: 14px;
                line-height: 16px;
            }
        }
    `,
};
